// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const VmwareFusionIcon = createSvgIcon(
  <svg width={24} height={24} fill="none" viewBox="0 0 24 24">
    <path
      fill="#00507F"
      fillRule="evenodd"
      d="M10.5 16.48H4.14a2.15 2.15 0 0 1-2.14-2.15V4.3c0-1.18.96-2.14 2.14-2.14h10.02c1.19 0 2.15.96 2.15 2.14v6.36l-.02 2.97a.4.4 0 0 1-.67.28l-2.78-2.79V6.21a.6.6 0 0 0-.6-.6H5.43v6.83c0 .33.27.6.6.6h4.94l2.76 2.75a.4.4 0 0 1-.28.67z"
      clipRule="evenodd"
    />
    <path
      fill="url(#vmware-fusion_svga)"
      fillRule="evenodd"
      d="M10.51 16.3H4.17a2.15 2.15 0 0 1-2.14-2.14V4.15C2.03 2.96 2.99 2 4.17 2H14.2c1.18 0 2.14.96 2.14 2.15v9.32a.4.4 0 0 1-.68.28l-2.79-2.79V6.04a.6.6 0 0 0-.59-.59H5.45v6.82c0 .33.27.6.6.6h4.94l2.76 2.75a.4.4 0 0 1-.28.67z"
      clipRule="evenodd"
    />
    <path
      fill="#A61F0B"
      fillRule="evenodd"
      d="M13.34 7.7h6.34c1.19 0 2.15.95 2.15 2.14v10.01c0 1.19-.96 2.15-2.15 2.15H9.66a2.15 2.15 0 0 1-2.14-2.15V13.5l.01-2.97a.4.4 0 0 1 .68-.28l2.78 2.79v4.92c0 .32.27.59.6.59h6.81v-6.82a.6.6 0 0 0-.59-.6h-4.95l-2.75-2.75a.4.4 0 0 1 .27-.67z"
      clipRule="evenodd"
    />
    <path
      fill="url(#vmware-fusion_svgb)"
      fillRule="evenodd"
      d="M13.34 7.52h6.34c1.19 0 2.15.96 2.15 2.15v10.01c0 1.19-.96 2.15-2.15 2.15H9.66a2.15 2.15 0 0 1-2.14-2.15v-6.36l.01-2.96a.4.4 0 0 1 .68-.28l2.78 2.78v4.92c0 .33.27.6.6.6h6.81v-6.82a.6.6 0 0 0-.59-.6h-4.95l-2.75-2.75a.4.4 0 0 1 .27-.68z"
      clipRule="evenodd"
    />
    <path
      fill="#00507F"
      fillRule="evenodd"
      d="M6.21 13.03h4.76l2.76 2.76a.4.4 0 0 1-.28.67l-2.96.01H5.2z"
      clipRule="evenodd"
    />
    <path
      fill="url(#vmware-fusion_svgc)"
      fillRule="evenodd"
      d="M5.97 12.86H11l2.76 2.76a.4.4 0 0 1-.28.67l-2.96.01H4.96z"
      clipRule="evenodd"
    />
    <defs>
      <radialGradient
        id="vmware-fusion_svga"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(0 14.0307 -14.0306 0 9.18 2)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#64BBEC" />
        <stop offset={1} stopColor="#006DB3" />
      </radialGradient>
      <radialGradient
        id="vmware-fusion_svgb"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(0 16.5017 -16.5016 0 14.67 7.52)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF7C75" />
        <stop offset={0.44} stopColor="#F2655A" />
        <stop offset={1} stopColor="#D4301A" />
      </radialGradient>
      <radialGradient
        id="vmware-fusion_svgc"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(0 14.0307 -14.0306 0 9.18 2)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#64BBEC" />
        <stop offset={1} stopColor="#006DB3" />
      </radialGradient>
    </defs>
  </svg>,
  "VmwareFusion",
);
export default VmwareFusionIcon;
